import React from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';

function Component1() {
  return (
    <div className="lading-page">
      <p>Component1</p>
    </div>
  );
}

export default Component1;
